import { render, staticRenderFns } from "./schedule_events_configuration.vue.js?vue&type=template&id=fded6832&vue3!=!../../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./schedule_events_configuration.vue?vue&type=template&id=fded6832&vue3"
import script from "./schedule_events_configuration.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./schedule_events_configuration.vue?vue&type=script&lang=js&vue3"
export * from "./schedule_events_configuration.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./schedule_events_configuration.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports